import {
    LOAD_API_SERVICE_DATA,
    LOAD_API_SERVICE_DATA_FAILED,
    LOAD_API_SERVICE_DATA_SUCCESS,
  } from "../types"
  
  const initialState = {
    serviceCards: [],
    loading: false,
    error: false,
    empty: false,
  }

  export default function (state = initialState, action) {
    switch (action.type) {
      case LOAD_API_SERVICE_DATA:
        return {
          ...state,
          loading: true,
          error: false,
          empty: false,
          serviceCards: [],
        }
      case LOAD_API_SERVICE_DATA_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          empty: false,
          serviceCards: [],
        }
      case LOAD_API_SERVICE_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          empty: action.payload.length == 0,
          serviceCards: action.payload,
        }
      default:
        return state
    }
  }
  